import { BellFilled } from '@ant-design/icons';
import { AdminRole } from 'constants/enums/roles';
import { incidencePaths } from 'constants/routePaths';
import GetFrontendConfig from 'hooks/getFrontConfig';
import { useIncidencePendingSummary } from 'hooks/incidencePendingSummary';
import { useAppSelector } from 'hooks/reduxHooks';
import { Link } from 'react-router';

type IncidencePendingBannerProps = {
  audience: 'admin' | 'supervisor';
};

export const IncidencePendingBanner = ({
  audience,
}: IncidencePendingBannerProps) => {
  const frontendConfig = GetFrontendConfig();
  const { user } = useAppSelector((state) => state.auth);
  const { employee } = useAppSelector((state) => state.employee);
  const isIncidencesModuleEnabled =
    frontendConfig?.isIncidencesModuleEnabled !== 'false';
  const isIncidenceAuthorizationsEnabled =
    frontendConfig?.isIncidenceAuthorizationsEnabled !== 'false';
  const isAdminUser = user?.role === AdminRole;
  const effectiveIsSupervisor =
    employee._id === user?._id
      ? Boolean(employee.isSupervisor)
      : Boolean(user?.isSupervisor);
  const canRenderForAudience =
    audience === 'admin'
      ? isAdminUser && isIncidenceAuthorizationsEnabled
      : effectiveIsSupervisor;
  const { hasPending } = useIncidencePendingSummary({
    enabled: Boolean(user && isIncidencesModuleEnabled && canRenderForAudience),
  });

  if (
    !user ||
    !isIncidencesModuleEnabled ||
    !canRenderForAudience ||
    !hasPending
  ) {
    return null;
  }

  const isAdminBanner = audience === 'admin';
  const approvalPath = `${incidencePaths.basePath}/${
    isAdminBanner ? incidencePaths.authorizations : incidencePaths.approvals
  }`;
  const pendingAction = isAdminBanner ? 'autorizar' : 'aprobar';

  return (
    <div
      className="dashboard-incidence-pending-banner"
      data-cy="dashboard-incidence-pending-banner"
    >
      <div className="dashboard-incidence-pending-banner-copy">
        <BellFilled />
        <span>
          {`Tienes solicitudes de incidencias pendientes por ${pendingAction}.`}
        </span>
      </div>
      <Link
        className="dashboard-incidence-pending-banner-link"
        data-cy="dashboard-incidence-pending-banner-link"
        to={approvalPath}
      >
        Ir a bandeja de solicitudes
      </Link>
    </div>
  );
};
